import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "38.318",
      width: "50",
      viewBox: "0 0 50 38.318"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M0 0v26.64h8.75v-2.717H4.766L8.75 20.89v-3.634l-5.984 4.72V4.356l5.985 4.72V8.75h4.265l-7.94-6.035H33.25L25.31 8.75h4.77l5.525-4.345V8.75h2.716V0H0zm11.68 11.68v26.64H50V11.68H11.68zm5.073 2.716H44.93L30.84 25.152 16.754 14.397zm-2.305 1.638l11.167 8.812-11.167 8.81v-17.62zm32.837 0V33.81l-11.27-8.913 11.27-8.863zM28.023 26.792l2.817 2.204 2.767-2.15 11.526 8.758H16.445l11.577-8.812z"
    }))
  );
});